import Vue from 'vue'
import VeeValidate from 'vee-validate'
import Notifications from 'vue-notification'
import axios from 'axios'

import App from './App'
import router from './router'
import store from './store'
import DB from './extensions/db'
import emitter from './extensions/emitter'
import download from './extensions/download'
import {PostMessageType} from './utils'

DB.then(() => {
  Vue.use(VeeValidate, {
    fieldsBagName: 'vFields'
  })
  Vue.use(Notifications)
  Vue.use(DB)
  Vue.use(emitter)
  Vue.use(download)
  Vue.http = Vue.prototype.$http = axios
  Vue.config.productionTip = false

  /* eslint-disable no-new */
  new Vue({
    components: { App },
    router,
    store,
    template: '<App/>'
  }).$mount('#app')
})

window.addEventListener('message', ({ origin, data }) => {
  if (origin === window.location.origin) {
    return
  }
  if (data.type === PostMessageType.GetDBDump) {
    DB.dump().then(data => {
      window.parent.postMessage({
        type: PostMessageType.GetDBDump,
        data: data
      }, '*')
    })
  }
  if (data.type === PostMessageType.LoadData) {
    const { db, defaultInterfaceList, serialNumber } = data.data
    ;(async () => {
      if (db) {
        if (DB.isValid(db)) {
          await DB.load(db)
        } else {
          console.log('工程文件版本过旧')
          DB.addDefaultInterface(defaultInterfaceList)
          Vue.prototype.$notify({
            group: 'alert',
            type: 'error',
            title: 'error',
            text: '工程文件版本过旧,请重新配置工程'
          })
        }
      } else {
        DB.addDefaultInterface(defaultInterfaceList)
      }
      if (serialNumber) {
        await DB.setSerialNumber(serialNumber)
      }
    })()
  }
})



// WEBPACK FOOTER //
// ./src/main.js